<!--
 * @Desc: 路由错误时显示的页面
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-03 09:41:19
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
-->
<template>
  <van-notice-bar :scrollable="false"> 您访问的页面未找到！ </van-notice-bar>
</template>

<script>
export default {};
</script>
